import {
  getConversationLoggingEnabled,
  getConversationLoggingRows,
  setConversationLoggingEnabled,
} from "@mirage/service-conversation";
import { useCallback, useEffect, useState } from "react";

/**
 * Hook to manage conversation logging. Should only be used in DEV settings.
 */
export function useConversationLoggingEnabled() {
  const [loggingEnabled, setLoggingEnabled] = useState(false);
  useEffect(() => {
    getConversationLoggingEnabled()
      .then((enabled) => setLoggingEnabled(enabled))
      .catch((e) => {
        throw e;
      });
  }, []);
  return {
    loggingEnabled,
    toggleLoggingEnabled: () => {
      const newValue = !loggingEnabled;
      setLoggingEnabled(newValue);
      setConversationLoggingEnabled(newValue);
    },
  };
}

/**
 * Hook to get all conversation logging rows. Should only be used in DEV settings.
 */
export function useConversationLoggingRows() {
  const [rows, setRows] = useState<string[]>([]);
  const refresh = useCallback(() => {
    getConversationLoggingRows()
      .then(setRows)
      .catch((e) => {
        throw e;
      });
  }, []);
  useEffect(() => {
    refresh();
  }, [refresh]);
  return { rows, refresh };
}
